import { TExerciseContent, TExerciseMatchItem } from '../rest/exercises/exercisesRest';

// mirrors backend exerciseValidation: rows generated before "format" was stored are told by the item shape
export const isMatchContent = (content: TExerciseContent): boolean =>
	content.format === 'match' || Array.isArray((content.items[0] as TExerciseMatchItem | undefined)?.pairs);

export const hasTranslatableText = (content: TExerciseContent): boolean =>
	!!content.items.length;
